export default {"src":"/_next/static/media/partner_bg.58ec03fc.svg","height":489,"width":1440,"blurWidth":0,"blurHeight":0};